import React from 'react';
import type { GameSessionData, GameStateController } from './GameStateController';

export const GameStateContext = React.createContext<{
  game : GameStateController,
  data? : GameSessionData,
}>({ game : null as any });
